import { render } from "./riwayat-pendidikan.vue?vue&type=template&id=3eb6f537"
import script from "./riwayat-pendidikan.vue?vue&type=script&lang=js"
export * from "./riwayat-pendidikan.vue?vue&type=script&lang=js"

import "./riwayat-pendidikan.vue?vue&type=style&index=0&id=3eb6f537&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__